import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { commonApi } from "./commonApi";
import auth from "./reducers/auth";
import snackbar from "./reducers/snackbar";
import landing from "./reducers/landing";
import videoDialog from "./reducers/videoDialog";

const appReducer = combineReducers({
  [commonApi.reducerPath]: commonApi.reducer,
  auth,
  snackbar,
  landing,
  videoDialog,
});

const rootReducer = (state, action) => {
  if (action.type === "DESTROY_SESSION") {
    localStorage.removeItem(process.env.REACT_APP_AUTH_HEADER);
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(commonApi.middleware),
});

export default store;
